import * as ACTIONS from '@/store/constants/actions.js';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { loadAndConvertLanguageFile } from '@/languages/language.js';

export const actions = {

    [ACTIONS.LOAD_ASYNC_LANGUAGE]({ commit, state }, language_file) {
        const language_name = state.current_language;

        return loadAndConvertLanguageFile(language_name, language_file).then((language) => {
            commit(MUTATIONS.ADD_LANGUAGE_FILE, language_file);
            commit(MUTATIONS.LOAD_LANGUAGE, {
                language_name,
                language,
            });
        });
    },
};
